import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const SubscriptionsPage = lazy(() => import('./SubscriptionsPage'));

const SubscriptionsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Subscriptions,
  routes: [
    {
      path: 'subscriptions',
      element: <SubscriptionsPage />,
    },
  ],
};

export default SubscriptionsConfig;
